import { useState, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { processFilterConstraints } from '../Filters/filterUtils'

export const useLazyLoading = ({
    setCurrentPageAction,
    setFirstAction,
    setRowsAction,
    setSortAction,
    setFilterAction,
    initialFilterState = null,
    initialSortState = [],
    setFilterStateAction,
    setSortStateAction
}) => {
    const [multiSortMeta, setMultiSortMeta] = useState(initialSortState || [])
    const [filters, setFilters] = useState(initialFilterState || null)
    const dispatch = useDispatch()

    const lazyLoadData = useCallback((event) => {
        const sortMeta = event.multiSortMeta || []
        const currentPage = Math.floor(event.first / event.rows) + 1
        const sortFields = sortMeta
            .map(sort => `${sort.field} ${sort.order === 1 ? 'asc' : 'desc'}`)
            .join(',')

        setFilters(event.filters)

        const filter = processFilterConstraints(event.filters)

        setMultiSortMeta(sortMeta)
        dispatch(setCurrentPageAction(currentPage))
        dispatch(setFirstAction(event.first))
        dispatch(setRowsAction(event.rows))
        dispatch(setSortAction(sortFields))
        dispatch(setFilterAction(filter))

        if (setFilterStateAction) {
            dispatch(setFilterStateAction(event.filters || null))
        }

        if (setSortStateAction) {
            dispatch(setSortStateAction(sortMeta))
        }
    }, [dispatch, setCurrentPageAction, setFirstAction, setRowsAction, setSortAction, setFilterAction, setFilterStateAction, setSortStateAction])

    return {
        multiSortMeta,
        filters,
        setFilters,
        setMultiSortMeta,
        lazyLoadData
    }
}
